import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/check" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M13.3337 4L6.00033 11.3333L2.66699 8", stroke: "#7C3AED", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
